import { apiGet } from '../../fetch/apiService';

export function getScreens(organizationId) {
	if (organizationId) {
		return apiGet('screens', { organization: organizationId });
	}
	return apiGet('screens');
}
